<template>
  <div>
    <top-nav-bar />
    <NuxtLoadingIndicator />

    <loading-indicator v-if="!$userStore.user_checked" />
    <template v-else-if="!$userStore.user">
      <div v-if="is_public" class="my-3">
        <NuxtPage />
      </div>
      <div v-else class="container my-3">
        <login />
      </div>
    </template>
    <template v-else-if="account_setup_complete">
      <div class="my-3">
        <NuxtPage />
      </div>
    </template>
    <div v-else class="container my-3">
      <div class="card">
        <div class="card-header text-big">
          {{ tr(`Notice`) }}
        </div>
        <div v-if="!$userStore.user.Verified" class="card-body text-center">
          <p>
            {{
              tr(`You have not yet verified your account. Please check your email for instructions.
                        If you have not received an email you can send another one by clicking below`)
            }}
          </p>
          <h5 class="mb-3">
            {{ $userStore.user.Email }}
          </h5>
          <div class="d-flex flex-row">
            <button class="btn btn-primary mx-auto" @click="resend_verification">
              {{ tr(`Resend`) }}
            </button>
          </div>
        </div>
        <div v-else class="card-body text-center">
          <div>{{ tr(`Your account has been verified, but is not set up.`) }}</div>
          <hr />
          <div>
            {{
              tr(
                'If this is your first time logging back in after prolonged inactivity, your local store management will need to re-add you to your store.',
              )
            }}
          </div>
          <div>
            {{ tr(`If you have newly registered this account, setup can take up to 24 hours.`) }}
          </div>
          <hr />
          <div>
            {{ tr('For assistance, please contact admin@myonesource.ca') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TopNavBar from '~/components/misc/TopNavBar.vue'
  import Login from '~/components/misc/Login.vue'
  import { tr } from '~/assets/scripts/helpers'

  export default {
    components: { TopNavBar, Login },
    data() {
      return {
        current_dropdown: null,
        loaded_dropdowns: [],
      }
    },
    computed: {
      account_setup_complete() {
        const user = this.$userStore.user
        if (user && user.Verified) {
          if (user.Role === 'vendor' && user.Vendors.length > 0) {
            return true
          }
          if (user.Stores.length > 0 && (user.Role === 'member' || user.Role === 'buyer')) {
            return true
          }
        }
        return false
      },
      is_public() {
        return this.$route.path.startsWith('/public')
      },
      browser_has_capabilities() {
        try {
          structuredClone([1, 2, 3].toSorted())
          return true
        } catch {
          return false
        }
      },
    },
    mounted() {
      if (
        this.$userStore.user &&
        this.$userStore.user.Stores.length > 0 &&
        this.$userStore.user.Role === 'buyer' &&
        this.$userStore.user.Stores[0][0] !== 1000
      ) {
        this.$toast.info(
          `Viewing page as store #${this.$userStore.user.Stores[0][0]} (${this.$userStore.user.Stores[0][1]})`,
        )
      }

      if (!this.browser_has_capabilities) {
        // suppress client side error logging
        window._error_logged = true

        // flash toast once per session
        if (!sessionStorage.getItem('browserWarning')) {
          this.$toast.warning(
            tr(
              'Your web browser is not up to date, not all parts of the site will function properly. Please consider updating',
            ),
            { duration: null },
          )
          sessionStorage.setItem('browserWarning', '1')
        }
      }
    },
    methods: {
      tr,
      resend_verification() {
        $api('/api/account/resend-verification', { method: 'POST' }).then((resp) => {
          if (resp.success) {
            this.$toast.success(tr(resp.success))
          }
        })
      },
    },
  }
</script>

<style></style>

<style scoped lang="scss">
  @import '@/assets/styles/custom';

  .custom-report ::before {
    color: $primary;
    content: '*';
  }

  .account-circle-icon {
    width: 20px;
    height: 20px;
    padding: 0;
  }

  .account-circle-icon * {
    width: 20px;
    height: 20px;
    padding: 0;
  }

  .email-icon path {
    color: $info;
    fill: white;
  }

  .email-icon * {
    width: 24px;
    height: 24px;
    margin-bottom: -4px;
  }

  .navbar-expand-md {
    height: 42px;
  }

  @media only screen and (max-width: 768px) {
    .navbar-expand-md {
      height: revert;
    }
  }

  .notification_banner {
    box-shadow: none;
    min-height: 31px;
    padding: 3px 20px 2px 20px;
    background-color: $secondary;
    color: #ffffff;
    text-align: center;
  }

  .nav-item {
    white-space: nowrap;
  }

  .notification-button {
    padding: 2px 5px 2px 5px;
    border: 1px solid white;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    color: white;
  }

  .notification-button:hover {
    color: $danger;
  }

  .navbar-dark {
    background-color: $dark;
  }

  .navbar-dark .navbar-nav .nav-link {
    color: rgba(255, 255, 255, 0.75);
  }

  .navbar-dark .navbar-nav .nav-link:hover {
    color: rgba(255, 255, 255, 0.9);
    cursor: pointer;
  }

  .wrapper {
    display: flex;
    width: 100%;
    align-items: stretch;
  }

  //#screen {
  //  width: 100%;
  //  padding-top: 42px;
  //}

  //#sidebar {
  //  min-width: 40px;
  //  max-width: 40px;
  //  min-height: 100vh;
  //  background: #fff;
  //  color: $secondary;
  //  border-top: 1px solid #fff;
  //  border-right: 1px solid $secondary;
  //  transition: all 0.3s;
  //  padding: 0;
  //}
  //
  //#sidebar ul li a {
  //  padding: 10px;
  //  font-size: 1.1em;
  //  display: block;
  //  color: $secondary;
  //}
  //
  //#sidebar ul li a:hover {
  //  outline: 0;
  //  background: $light;
  //}
  //
  //#sidebar ul li.active > a, a[aria-expanded="true"] {
  //  color: #444;
  //  outline: 0;
  //  background: $primary;
  //}
</style>
